"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
function InviteByEmailButton({ onInvite }) {
    const sendEmail = () => {
        onInvite();
    };
    return ((0, jsx_runtime_1.jsxs)(StyledButton, { onClick: sendEmail, "data-e2e": 'InviteByEmailButton_StyledButton', children: [(0, jsx_runtime_1.jsx)(StyledTitle, { "data-e2e": 'InviteByEmailButton_StyledTitle', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.members.inviteEmail) }), (0, jsx_runtime_1.jsx)(StyledIcon, { name: ui_1.Icons.Send_Mail, height: 10, width: 10, "data-e2e": 'InviteByEmailButton_StyledIcon' })] }));
}
const StyledButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  display: flex;
  align-items: center;
  padding: 5px 7px;
  font-size: 12px;
  cursor: pointer;
  margin: 5px 0;
`;
const StyledTitle = styled_components_1.default.span `
  text-transform: uppercase;
  white-space: nowrap;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  padding-left: 3px;
`;
exports.default = InviteByEmailButton;
